import { Component } from '@angular/core';
import { IdeateChallengeComponent } from '../ideate-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-ideate-ideas',
  templateUrl: './ideate-ideas.component.html',
  styleUrls: ['./ideate-ideas.component.scss']
})
export class IdeateIdeasComponent {

  constructor(public ideateChallengeComponent: IdeateChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.ideateChallengeComponent?.brainstorm_content || [];
    this.aiService.openSidebar(
      'ideate', 'ideas', context,
      'Generate 5 creative ideas {persona} to solve the challenge. Current context: {context}',
      'brainstorm_content', this.ideateChallengeComponent
    );
  }
}
